module.exports = __webpack_public_path__ + "static/media/logo-postgresql-200.d1a538c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/tech-stack/logo-postgresql-200.png
// module id = 57
// module chunks = 0